import locales from './locales';
import contentTypes from './content-types';
import isoLocales from './iso-locales';
import settings from './settings';

export default {
  locales,
  'iso-locales': isoLocales,
  'content-types': contentTypes,
  settings,
};
